import { Heading } from "evergreen-ui";
import { ProviderEventUnreadCount } from "providerapp/notification/ProviderEventUnreadCount";
import { Helmet } from "react-helmet";
import { useRouteMatch, Switch, Route, Redirect } from "react-router";
import { AzureOauth2Environment } from "security/component/azure/AzureOauth2Environment";
import { ProviderUserList } from "usermanagementapp/component/ProviderUserList";
import { VISIBLE_FIELDS } from "usermanagementapp/domain/visible-fields";
import { ProviderLayout } from "./layout/ProviderLayout";
import { AzurePortalSecuredRoute } from "security/component/azure/AzurePortalSecuredRoute";
import { InternalUserProviderViewAs } from "providerapp/InternalUserProviderViewAs";

export const AzureProviderUserManagementApp = () => {
    const {url: rootUrl} = useRouteMatch();
    return (

        <AzureOauth2Environment applicationType={'User Management'}>
            <InternalUserProviderViewAs app="user-management">
            <Helmet>
                <meta
                    name="description"
                    content="User Management - The Catalight Care Services Provider Portal"
                />
                <title>User Management - The Catalight Care Services Provider Portal</title>
            </Helmet>
                <ProviderEventUnreadCount>
                    <Switch>
                        <Route path={`${rootUrl}`} exact
                               render={() => <Redirect to={`${rootUrl}/provideruser/list`}/>}/>
                        <AzurePortalSecuredRoute path={`${rootUrl}`}
                                           allowedRoles={['PROVIDER_SUPPORT']}
                                           children={
                                               <ProviderLayout
                                                   header={<Heading size={700}>User Management</Heading>}
                                                   content={
                                                       <AzurePortalSecuredRoute
                                                           path={`${rootUrl}/provideruser/list`}
                                                           children={
                                                               <ProviderUserList
                                                                   fieldsToRender={VISIBLE_FIELDS}
                                                                   tableBodyHeight='40vh'
                                                               />}
                                                       />
                                                   }
                                               />
                                           }
                        />
                    </Switch>
                </ProviderEventUnreadCount>
            </InternalUserProviderViewAs>
        </AzureOauth2Environment>
    );
}